import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "download",
  "use": "download-usage",
  "viewBox": "0 0 16 15",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 15\" id=\"download\">\n  <path fill-rule=\"evenodd\" d=\"M372.5,209h-12a2,2,0,0,1-2-2v-3a1,1,0,0,1,2,0v2a1,1,0,0,0,1,1h10a1,1,0,0,0,1-1v-2a1,1,0,0,1,2,0v3A2,2,0,0,1,372.5,209Zm-5.2-4.431a0.982,0.982,0,0,1-.8.431s-0.01,0-.015,0-0.024.007-.036,0.007a1,1,0,0,1-.708-0.293l-2.967-3.015a1,1,0,1,1,1.417-1.415l1.309,1.339V195a1,1,0,0,1,2,0v6.545l1.278-1.272a1,1,0,0,1,1.417,1.414Z\" transform=\"translate(-358.5 -194)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/download.svg
// module id = null
// module chunks = 